interface LogoProps {
  className?: string;
}

export default function Logo({ className = "w-8 h-8" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="100%" 
      height="100%" 
      viewBox="0 0 33 33" 
      fill="none" 
      preserveAspectRatio="xMidYMid meet" 
      aria-hidden="true" 
      role="img"
      className={className}
    >
      <g clipPath="url(#clip0_54617_12190)">
        <mask id="mask0_54617_12190" style={{maskType:'luminance'}} maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="33">
          <path d="M32.5748 0H0V33H32.5748V0Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_54617_12190)">
          <path d="M5.67592 11.7505C5.67228 10.6065 5.66742 9.46302 5.66438 8.31895C5.66256 7.5111 5.66438 6.70389 5.66438 5.86709H11.3181V0H21.2575V5.86394L21.2642 5.85701H11.3175V11.743H5.66803L5.67592 11.7505Z" fill="#0C0F0C"/>
          <path d="M21.2574 27.1281V32.9996H11.3319V27.1483H5.68249C5.6746 27.0683 5.66549 27.0192 5.66549 26.9701C5.66489 25.1113 5.66489 23.2526 5.66549 21.3945C5.66549 21.3429 5.67339 21.2919 5.67703 21.2402L5.66792 21.2497H11.3252V27.1344H21.2635L21.2574 27.1281Z" fill="#0C0F0C"/>
          <path d="M5.67724 21.2405C5.01425 21.2449 4.35064 21.2512 3.68765 21.2524C2.55169 21.2543 1.41512 21.2524 0.279165 21.2524C0.190523 21.2524 0.101881 21.2524 0.000488281 21.2524V11.7497H5.67663L5.66874 11.7422C5.66874 14.9112 5.66874 18.0803 5.66874 21.2493L5.67785 21.2398L5.67724 21.2405Z" fill="#0C0F0C"/>
          <path d="M26.936 11.7497H32.5745V21.2317C32.5181 21.2386 32.4634 21.2518 32.4088 21.2518C30.6171 21.2524 28.826 21.2524 27.0344 21.2518C27.0016 21.2518 26.9688 21.2455 26.9354 21.2417L26.9409 21.248C26.9378 21.1882 26.9312 21.1284 26.9312 21.0686C26.9312 18.0198 26.9312 14.9704 26.9312 11.9216C26.9312 11.8618 26.9378 11.802 26.9415 11.7422L26.9354 11.7497H26.936Z" fill="#0C0F0C"/>
          <path d="M21.2576 5.86372H26.9362V11.7503L26.9422 11.7428H21.254C21.254 10.7687 21.2527 9.83241 21.254 8.89675C21.2558 7.88364 21.2606 6.87053 21.2643 5.85742L21.2576 5.86435V5.86372Z" fill="#0C0F0C"/>
          <path d="M26.9353 21.2425V27.1096C26.8643 27.1209 26.8102 27.1373 26.7562 27.1373C24.956 27.1385 23.1559 27.1379 21.3557 27.1373C21.3229 27.1373 21.2901 27.131 21.2567 27.1272L21.2628 27.1335C21.2598 27.0907 21.2537 27.0479 21.2537 27.005C21.2537 25.1564 21.2531 23.3077 21.2537 21.4584C21.2537 21.3936 21.2677 21.3287 21.2774 21.2475H26.9408L26.9353 21.2412V21.2425Z" fill="#0C0F0C"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_54617_12190">
          <rect width="32.5748" height="33" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
